/**
 * File view component.
 * @module components/theme/View/FileView
 */

import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import baseMessages from '@fhnw/messages/base';

/**
 * File view component class.
 * @function FileView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const FileView = ({ content }) => {
  function getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes /= 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  }

  const intl = useIntl();

  return (
    <div id="file-view">
      <article id="page-document" className="has-aside">
        <section className="content">
          <div className="blocks-group-wrapper transparent">
            <h1 className="documentFirstHeading">{content.title}</h1>
            {content.description && (
              <p className="documentDescription">{content.description}</p>
            )}
            {content.file?.download && (
              <div style={{ display: 'flex', gap: '1rem' }}>
                <a
                  className="btn btn-primary"
                  href={flattenToAppURL(content.file.download)}
                >
                  {intl.formatMessage(baseMessages.DownloadDocument)}
                </a>
                {content.file['content-type'] &&
                  content.file['content-type'] === 'application/pdf' && (
                    <a
                      className="btn btn-primary"
                      href={flattenToAppURL(
                        content.file.download.replace(
                          '@@download',
                          '@@display-file',
                        ),
                      )}
                    >
                      {intl.formatMessage(baseMessages.OpenDocumentInBrowser)}
                    </a>
                  )}
              </div>
            )}
            {content.file?.filename && (
              <p>
                {content.file.filename !== content.title &&
                  content.file.filename}
                {content.file.size && (
                  <span>
                    &nbsp;({getReadableFileSizeString(content.file.size)})
                  </span>
                )}
              </p>
            )}
          </div>
        </section>
        <aside className="sidebar-nav-right-wrapper"></aside>
      </article>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
FileView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    file: PropTypes.shape({
      download: PropTypes.string,
      filename: PropTypes.string,
    }),
  }).isRequired,
};

export default FileView;
